import { MatDialogRef } from '@angular/material/dialog';
import { TableDialogService } from '@morningstar/shared/base/base-service';
import { Subject } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { BaseComponent } from './base-component';

export abstract class TableDialogComponent<T> extends BaseComponent {

  onSave = new Subject();
  onSave$ = this.onSave.asObservable();

  // move subscription down if more observables make it in here
  closeDialog$ = this.service.closeDialog$.pipe(
    take(1),
    tap(_ => this.dialogRef.close(true))
  ).subscribe();

  constructor(protected service: TableDialogService<T>, protected dialogRef: MatDialogRef<any>) {
    super(service);
  }

  save() {
    this.onSave.next();
  }
}
